import React, { useEffect, useState } from "react";
import { Form, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Utils from "../../configs/Utils";
import Enums from "../../configs/Enums";
import MailTemplateBlock from "../../Components/MailTemplates";
import PageHeader from "../../Components/Common/PageHeader";

const STORAGE_KEY = "mailtemplate_selected_workspace";

const MailTemplatesPage = () => {
  const [workspaces, setWorkspaces] = useState([]);
  const [selectedWorkspaceId, setSelectedWorkspaceId] = useState(
    () => localStorage.getItem(STORAGE_KEY) || ""
  );
  const [loadingWorkspaces, setLoadingWorkspaces] = useState(true);

  useEffect(() => {
    Utils.setPageTitle("Email Templates");
  }, []);

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        const response = await Utils._apiRequest({
          path: Enums.endpoints.workspace.ALL,
          type: "GET",
          query: { page: 1, limit: 100 },
        });
        setWorkspaces(response.data || []);

        // If saved workspace no longer exists, clear selection
        if (selectedWorkspaceId && response.data) {
          const exists = response.data.some(
            (ws) => ws._id === selectedWorkspaceId
          );
          if (!exists) {
            setSelectedWorkspaceId("");
            localStorage.removeItem(STORAGE_KEY);
          }
        }
      } catch (error) {
        console.log("Failed to fetch workspaces:", error.message);
      } finally {
        setLoadingWorkspaces(false);
      }
    };

    fetchWorkspaces();
  }, []);

  const handleWorkspaceChange = (e) => {
    const value = e.target.value;
    setSelectedWorkspaceId(value);
    if (value) {
      localStorage.setItem(STORAGE_KEY, value);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  };

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader
          title="Email Templates"
          description="Manage email templates for your workspaces"
          icon={faEnvelope}
        />

        <Row className="mb-3">
          <Col md={4}>
            <Form.Group>
              <Form.Label className="fw-semibold">Select Workspace</Form.Label>
              <Form.Select
                value={selectedWorkspaceId}
                onChange={handleWorkspaceChange}
                disabled={loadingWorkspaces}
              >
                <option value="">
                  {loadingWorkspaces ? "Loading workspaces..." : "-- Select a workspace --"}
                </option>
                {workspaces.map((ws) => (
                  <option key={ws._id} value={ws._id}>
                    {ws.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {selectedWorkspaceId ? (
          <MailTemplateBlock workspaceId={selectedWorkspaceId} />
        ) : (
          <div className="my-3 p-4 bg-body rounded shadow-sm text-center text-muted">
            <FontAwesomeIcon icon={faEnvelope} size="2x" className="mb-2" />
            <p className="mb-0">Please select a workspace to view email templates.</p>
          </div>
        )}
      </div>
    </main>
  );
};

export default MailTemplatesPage;
